export default function ClientLogoShowcase() {
  const partners = [{
    name: "BW Vacation Rentals",
    url: "https://aaeagleplumbing.com/wp-content/uploads/2026/08/BWVacationRentals.png"
  }, {
    name: "Claude Pepper Federal Building",
    url: "https://aaeagleplumbing.com/wp-content/uploads/2026/08/claude_pepper_federal_building.png"
  }, {
    name: "Aventura Medical Tower",
    url: "https://aaeagleplumbing.com/wp-content/uploads/2026/08/Aventura-Medical-Tower.png"
  }, {
    name: "Novotel",
    url: "https://aaeagleplumbing.com/wp-content/uploads/2026/08/Novotel.png"
  }, {
    name: "Wilkie D. Ferguson Federal Courthouse",
    url: "https://aaeagleplumbing.com/wp-content/uploads/2026/08/wilkie_d_ferguson_federal_courthouse.png"
  }, {
    name: "Miami Hurricanes",
    url: "https://aaeagleplumbing.com/wp-content/uploads/2026/08/Miami-Hurricanes.png"
  }, {
    name: "The Diplomat Oceanfront",
    url: "https://aaeagleplumbing.com/wp-content/uploads/2026/08/The-Diplomat-Oceanfront.jpg"
  }, {
    name: "Fisher Island",
    url: "https://aaeagleplumbing.com/wp-content/uploads/2026/08/fisherisland.png"
  }, {
    name: "Atkins Federal Courthouse",
    url: "https://aaeagleplumbing.com/wp-content/uploads/2026/08/atkins_federal_courthouse.png"
  }];

  // Se duplica 4 veces para asegurar que el carrusel infinito no tenga espacios vacíos en pantallas anchas
  const marqueeItems = [...partners, ...partners, ...partners, ...partners];
  return <section data-section-id="2072" id="clientlogoshowcase" className="bg-background text-foreground py-14 md:py-16 overflow-hidden">
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-center">
          {/* Header Section */}
          <div className="lg:col-span-3">
            <div className="font-sans text-xs md:text-[13px] font-medium uppercase tracking-[0.18em] text-foreground">
              <span className="text-primary mr-1.5">§</span>
              02 / Our Clients
            </div>
            <p className="mt-3 font-sans text-xs md:text-sm tracking-[0.04em] uppercase text-muted">
              Commercial · Residential · Industrial
            </p>
          </div>

          {/* Marquee Section */}
          <div className="lg:col-span-9 relative">
            <div className="group relative overflow-hidden" style={{
            maskImage: "linear-gradient(to right, transparent 0%, black 8%, black 92%, transparent 100%)",
            WebkitMaskImage: "linear-gradient(to right, transparent 0%, black 8%, black 92%, transparent 100%)"
          }}>
              <div
            /* Se eliminó la clase arbitraria de Tailwind y se reemplazó por "custom-marquee-speed" */ className="flex items-center gap-12 md:gap-16 whitespace-nowrap custom-marquee-speed group-hover:[animation-play-state:paused] transition-[animation-play-state] duration-300" style={{
              width: "max-content"
            }}>
                {marqueeItems.map((logo, i) => <div data-index={i} key={i} className="flex-shrink-0 cursor-default select-none">
                    <img src={logo.url} alt={logo.name} className="h-16 w-16 md:h-24 md:w-24 object-contain opacity-60 hover:opacity-100 transition-opacity duration-[240ms] ease-out" />
                  </div>)}
              </div>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="mt-12 md:mt-14 flex items-center">
          <div className="h-px flex-1 bg-border" />
          <div className="size-1.5 bg-primary ml-0" />
        </div>
      </div>

      {/* CSS estándar asegurado que no será sobreescrito por la plataforma */}
      <style>{`
        @keyframes grain-marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .custom-marquee-speed {
          animation: grain-marquee 100s linear infinite;
          animation-play-state: running;
        }
      `}</style>
    </section>;
}